const useIsOnPrem = () => process.buildConfigs.name === 'msi' || process.buildConfigs.name === 'k8s';

export default useIsOnPrem;
